import { useEffect, useState } from 'react';
import { IProcesso } from '../../interfaces/processo.interface';
import { fetchProcessos } from '../../services/processoService';

const useFetchProcessos = () => {
  const [processos, setProcessos] = useState<IProcesso[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getProcessos = async () => {
      try {
        const data = await fetchProcessos();
        setProcessos(data);
      } catch (err) {
        setError('Falha ao buscar processos');
      } finally {
        setLoading(false);
      }
    };

    getProcessos();
  }, []); // Remova `processos` das dependências

  return { processos, loading, error };
};

export default useFetchProcessos;
